import { IDashboardComponent, IDashboardExtraSectionStatusValue, IDashboardExtraSectionStatusValueCheckType, IDashboardMetadata } from '../dashboard-metadata.service';
import { LbdmRevenueUsdInfoComponent } from '../info/lbdm-revenue-usd-info.component';
import { LbdmDashboardFiltersComponent } from '../filters/lbdm/lbdm-dashboard-filters.component';
import { LbdmDashboardHeaderComponent } from '../header/lbdm-dashboard-header.component';
import { DateType } from '../../../../shared/services/date.util';

const infoComponent:IDashboardComponent = {
  name: LbdmRevenueUsdInfoComponent
};

export const LBDM_DASHBOARD_CONFIG:IDashboardMetadata = {
    title: 'LBDM Checklist',
    filterComponent: {
      name: LbdmDashboardFiltersComponent
    },
    headerComponent: {
      name: LbdmDashboardHeaderComponent
    },
    mapping: {
      autoload: 'autoload'
    },
    reports: [
      {
        id: 89,
        key: 'CUSTOMERS_WITH_ORDERS_6M',
        fixedFilters: {
          Dewitho: '<=6', //with/without orders: With orders in last 6 months
          Deproty_ds: '<>822' //exclude demo shops
        },
        mapping: {
          Decounm: 'countryId',
          Decomnm: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.NA
        }
      },
      {
        id: 89,
        key: 'CUSTOMERS_WITHOUT_ORDERS_6M',
        fixedFilters: {
          Dewitho: '>6', //with/without orders: Without orders in last 6 months
          Production_description: '1', //in production: YES
          Deproty_ds: '<>822', //exclude demo shops
          Delcoal_ds: 1, //allowed to contact local customer: YES
          Desprst_ds: '@ACT@@STEADY@' //master webshop phase: Setup-Live
        },
        mapping: {
          Decounm: 'countryId',
          Decomnm: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.NA
        }
      },
      {
        id: 89,
        key: 'CUSTOMERS_GLOBAL_ORDERS',
        fixedFilters: {
          Dewitho: 'is null', //with/without orders: Without any orders
          Dewithc: ' ', //with catalog: YES
          Dewithg: '<=6', //with/without orders in other countries: With orders in last 6 months
          Production_description: '1', //in production: YES
          Deproty_ds: '<>822',  //exclude demo shops
          Delcoal_ds: 1           //allowed to contact local customer: YES
        },
        mapping: {
          Decounm: 'countryId',
          Decomnm: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.NA
        }
      },
      {
        id: 89,
        key: 'CUSTOMERS_WITHOUT_AGGREMENT',
        fixedFilters: {
          Deagrst_ok: '0', //agreement status OK: Agreement status not OK
          Decredt_FROM: '01/01/2000', //creation date
          Deproty_ds: '<>822', //exclude demo shops
          Desprst_ds: '@ACT@@STEADY@' //master webshop phase: Setup-Live
        },
        mapping: {
          Decounm: 'countryId',
          Decomnm: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.AVAILABLE,
          newValue: IDashboardExtraSectionStatusValue.OPTIONAL_NOT_AVAILABLE,
          checkType: IDashboardExtraSectionStatusValueCheckType.GT
        }
      },
      {
        id: 89,
        key: 'LEADS_WITHOUT_AGGREMENT',
        fixedFilters: {
          Desprst_ds: '@PRESALES@',  //master webshop phase: New
          Deagrst_ok: '0', //agreement status OK: Agreement status not OK
          Decredt_FROM: '01/01/2000', //creation date
          Deproty_ds: '<>822' //exclude demo shops
        },
        mapping: {
          Decounm: 'countryId',
          Decomnm: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.AVAILABLE,
          newValue: IDashboardExtraSectionStatusValue.OPTIONAL_NOT_AVAILABLE,
          checkType: IDashboardExtraSectionStatusValueCheckType.GT
        }
      },
      {
        id: 89,
        key: 'CUSTOMERS_WITHOUT_USERS',
        comments: `These customers have no users located in your country.<br>\n
                     They may however have central purchasers located in a different country with access rights to to purchase in your country.<br>\n
                     The list only shows customers in STEADY STATE (ordering) and for which the Leading Account Manager (LAM) has indicated that we are allowed to approach the customer locally.<br>\n
                     The objective is to do some research on this customer in your country and try to identify the right contact for purchases.<br>\n 
                     Once you have identified one or more users, simply click the ADD NEW USER url in the report next to the customer name. Send this user the generic id so he can registerer on our system and view the catalogue with his special pricing and corporate standards.<br>\n
                     If you need help to do this the first time, please contact us either via live chat when on GA or by clicking the Raise issue url next to the customer name.`,
        fixedFilters: {
          Desprst_ds: '@ACT@@STEADY@', //master webshop phase: Setup-Live
          Denousr2: 'NOT', //with/without local customer users: Wihtout users
          Delcoal_ds: 1, //allowed to contact local customer: YES
          Deproty_ds: '<>822', //exclude demo shops
          Decredt_FROM: '01/01/2000' //creation date
        },
        mapping: {
          Decounm: 'countryId',
          Decomnm: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.AVAILABLE,
          newValue: IDashboardExtraSectionStatusValue.OPTIONAL_NOT_AVAILABLE,
          checkType: IDashboardExtraSectionStatusValueCheckType.GT
        }
      },
      {
        id: 118,
        key: 'UNREGISTERED_USERS',
        comments: `These are users we or you have uploaded onto the system and who have received a generic id. <br>\n 
                     You can see when the generic id was sent to the user. You can resend the id or send the user a mail asking him if he needs help to register. <br>\n 
                     As long as a user has not registered he cannot place an order.`,
        fixedFilters: {
          Decomty_ds: 'C', //company type: Customer
          Deregis: 0, //registered: NO
          Delcoal_ds: 1, //allowed to contact local customer: YES
          Desprst: '@STEADY@', //master webshop phase: Live
          Dencepp: 1 //only non-CEPP: YES
        },
        mapping: {
          Decounm: 'countryId',
          Pacomnm: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.AVAILABLE,
          newValue: IDashboardExtraSectionStatusValue.OPTIONAL_NOT_AVAILABLE,
          checkType: IDashboardExtraSectionStatusValueCheckType.GT
        }
      },
      {
        browselistCode: 'USERS',
        key: 'REGISTERED_USERS_NO_ORDERS',
        comments: `These users have registered on our system at one point but they have not placed an order yet or they have placed an order but not in the last 6 months.<br>\n 
                     The objective is to contact these users to ask them if they need help. Maybe you can propose a visit and or do a demo of GA.<br>\n
                     You can send a mail to these users with a link to the catalogue to make it easy for them to place the first order.<br>\n 
                     If you need help from us, simply click Raise an issue to contact the Global Business Development Manager (GBDM) at ACSL and he will help you win or revive this business locally.`,
        fixedFilters: {
          Delcoal_ds: 1 //allowed to contact local customer: YES
        },
        mapping: {
          Lbdm1: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.AVAILABLE,
          newValue: IDashboardExtraSectionStatusValue.OPTIONAL_NOT_AVAILABLE,
          checkType: IDashboardExtraSectionStatusValueCheckType.GT
        }
      },
      {
        id: 89,
        key: 'CUSTOMERS',
        comments: 'These are all your active ACSL customers today.',
        fixedFilters: {
          Decredt_FROM: '01/01/2000', //creation date
          Deproty_ds: '<>822', //exclude demo shops
          Delcoal_ds: 1 //allowed to contact local customer: YES
        },
        mapping: {
          Decounm: 'countryId',
          Decomnm: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.NA
        }
      },
      {
        id: 89,
        key: 'LEADS',
        fixedFilters: {
          Desprst_ds: '@PRESALES@', //master webshop phase: New
          Decredt_FROM: '01/01/2000', //creation date
          Deproty_ds: '<>822' //exclude demo shops
        },
        mapping: {
          Decounm: 'countryId',
          Decomnm: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.NA
        }
      },
      {
        id: 89,
        key: 'CUSTOMERS_NO_LOCAL_CONTACT',
        fixedFilters: {
          Decredt_FROM: '01/01/2000', //creation date
          Delcoal_ds: 0, //allowed to contact local customer: NO
          Deproty_ds: '<>822' //exclude demo shops
        },
        mapping: {
          Decounm: 'countryId',
          Decomnm: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.NA
        }
      },
      {
        id: 89,
        key: 'CUSTOMERS_CENTRAL_PROCUREMENT',
        fixedFilters: {
          Decredt_FROM: '01/01/2000', //creation date
          Deordpr_ds: 1, //order process: Central ordering
          Deproty_ds: '<>822' //exclude demo shops
        },
        mapping: {
          Decounm: 'countryId',
          Decomnm: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.NA
        }
      },
      {
        id: 111,
        key: 'CUSTOMERS_MIN_SLA_2D',
        comments: `These are customers for which your average SLA (time between receipt of order and placement of order) exceeds 2 working days.<br>\n
                     This SLA is monitored very closely by all customers. If you cannot place an order within 2 working days or answer a price quote, please use the appropriate pending status. <br>\n 
                     Orders and quotes which you put in pending are excluded from the SLA report.`,
        fixedFilters: {
          Dependi: 0, //pending orders: Pending excluded
          Deslava: '>2', //SLA: >2
          Dereqst: 0, //only closed orders: NO
          //Dedate1: DateType.ONE_YEAR_AGO, no longer exists in the report
          Deslace: 'O.deorddt, nvl(O.depladt, sysdate)' //SLA type: Ordered -> Placed
        },
        mapping: {
          Deccoid: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.AVAILABLE,
          newValue: IDashboardExtraSectionStatusValue.NA,
          checkType: IDashboardExtraSectionStatusValueCheckType.GT
        },
        extraTextValue: {
          report: {
            id: 32,
            name: 'View order detail',
            fixedFilters: {
              Decredt_FROM: DateType.ONE_YEAR_AGO,
              Deslace: ',round(pck_tools.BUSINESSDAYS(OH.deorddt,nvl(OH.depladt,sysdate)),1) as deslava '
            },
            mapping: {
              Deccoid: 'companyCountryId'
            }
          }
        }
      },
      {
        browselistCode: 'USERS',
        key: 'UPLOADED_USERS',
        fixedFilters: {
          Delcoal_ds: 1 //allowed to contact local customer: YES
        },
        mapping: {
          Lbdm2: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.AVAILABLE,
          newValue: IDashboardExtraSectionStatusValue.OPTIONAL_NOT_AVAILABLE,
          checkType: IDashboardExtraSectionStatusValueCheckType.EQ
        }
      },
      {
        browselistCode: 'USERS',
        key: 'TOP_USERS',
        fixedFilters: {
          Delcoal_ds: 1 //allowed to contact local customer: YES
        },
        mapping: {
          Lbdm3: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.NA
        }
      },
      {
        id: 89,
        key: 'REVENUE_LAST_6M',
        fixedFilters: {
          Dewitho: '<=6',  //with/without orders: With orders in last 6 months
          Deproty_ds: '<>822' //exclude demo shops
        },
        mapping: {
          Decounm: 'countryId',
          Decomnm: 'companyCountryId'
        },
        extraStatus: {
          defaultValue: IDashboardExtraSectionStatusValue.NA
        },
        aggregates: {
          sum: true
        },
        infoComponent
      }
    ]
  }
;